import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SessionService } from '@edl-development/edl-common';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationItemId } from 'src/app/modals/edl-modal-details/navigation-item-id.enum';
import { CplRequestItem } from 'src/app/model/cpl-request-item.model';
import { CplUserRequest } from 'src/app/model/cpl-user-request.model';
import { RequestItemService } from 'src/app/services/request-item.service';
import { UserRequestDetailsModal } from 'src/app/requests/modals/sm-user-request-details-modal.component';
import { firstValueFrom } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { RequestHelpersService } from 'src/app/services/request-helpers/request-helpers.service';

@Component({
    selector: 'user-request-item-evidence',
    templateUrl: './user-request-item-evidence.component.html',
    styleUrls: ['./user-request-item-evidence.component.scss']
})
export class UserRequestItemEvidenceComponent implements OnInit {
    private _requestItem: CplRequestItem;
    private _canManageItem: boolean = false;
    
    @Input() userRequest: CplUserRequest;
    @Input() isUser: boolean = false;
    @Input() 
    get requestItem() { 
        return this._requestItem;
    }

    set requestItem(value: CplRequestItem) {
        this._requestItem = value;
        this._canManageItem = this.requestHelpersService.canManageItem(this.requestItem, this.sessionService.user);
    };

    @Output() onRefreshList = new EventEmitter<void>();

    get CanManageItem() {
        return this._canManageItem;
    }

    NavigationItemId = NavigationItemId;

    constructor(
        private ngbModal: NgbModal,
        private requestItemService: RequestItemService,
        private requestHelpersService: RequestHelpersService,
        private sessionService: SessionService,
        private cdr: ChangeDetectorRef
    ) { }

    ngOnInit(): void { }

    public async openDetails() {
        // Show immediate loading feedback
        this.sessionService.Loading(true);
        
        try {
            const shouldRefresh = await this.openDetailsModal(this.userRequest);
            if (shouldRefresh) {
                this.refreshList(); 
            }
        } catch (error) {
            console.log('Modal dismissed or error occurred:', error);
            this.refreshList();
        } finally {
            this.sessionService.Loading(false);
        }
    }

    private async openDetailsModal(userRequest: CplUserRequest, navigationItemId: NavigationItemId = NavigationItemId.DETAILS) {
        let modalRef = this.ngbModal.open(UserRequestDetailsModal, {
            size: 'lg',
            backdrop: 'static',
            windowClass: 'edl-modal-details'
        });

        modalRef.componentInstance.userRequest = userRequest;
        modalRef.componentInstance.request = this.requestItem; 
        modalRef.componentInstance.navigationItemId = navigationItemId;

        try {
            const completeRequestItem = await firstValueFrom(
                this.requestItemService.getRequestItem(this.requestItem.RequestID, true)
            );
            
            modalRef.componentInstance.updateRequestData(completeRequestItem);
            this.cdr.detectChanges();
    
            
        } catch (error) {
            console.error('Error fetching complete request item:', error);
        }

        return modalRef.result;
    }

    private refreshList() {
        this.onRefreshList.emit();
    }
}
